import React, { useMemo } from 'react';
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import DtvText from '@directv-digital/dds.ui.dtv-text';
import Button from '@directv-digital/fusion.atoms.button';
import DtvTheme from '@directv-digital/dds.ui.dtv-theme';

const bps = DtvTheme.breakpoints;

const RedirectModal = ({
  id,
  redirectModalHeading,
  redirectModalSubheading,
  redirectModalPrimaryCta,
  redirectModalSecondaryCta,
  redirectModalTargetUrl,
  handleToggleRedirectModal,
  handleRedirectModalClick
}) => {
  const RedirectCta = useMemo(() => (
    <Button
      buttontype='primary' mode='light'
      size='large'
      onClick={() =>  {
        handleRedirectModalClick(redirectModalPrimaryCta, redirectModalTargetUrl)
        window.location.href = redirectModalTargetUrl.split("directv.com")?.[1];
      }}
      sx={{
        margin: '0 24px 0 0',
        width: 'calc(60% - 24px)',
        [bps.down(bps.values.sm)]: {
          width: '100%',
          margin: '0 0 24px 0'
        },
        [bps.up(bps.values.sm)]: {
          maxWidth: '300px'
        }
      }}
    >{redirectModalPrimaryCta}
    </Button>
  ), [redirectModalPrimaryCta, redirectModalTargetUrl, handleRedirectModalClick]);

  const CancelCta = useMemo(() => (
    <Button
      buttontype='secondary' mode='light'
      size='large'
      onClick={ () => handleToggleRedirectModal(redirectModalSecondaryCta)}
      sx={{
        margin: 0,
        width: '40%',
        [bps.down(bps.values.sm)]: {
          width: '100%'
        },
        [bps.up(bps.values.md)]: {
          maxWidth: '200px'
        }
      }}
    >{redirectModalSecondaryCta}
    </Button>
  ), [redirectModalSecondaryCta]);

  return (
    <DtvBox id={`${id}-redirect-ctnr`}
      sx={{
        display: "flex",
flexDirection: "column",
        [bps.between(bps.values.sm, bps.values.md)]: {
          padding: "0 32px"
        }
       }}>
      <DtvBox sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '20px'
      }}>
          {redirectModalHeading?.content && (
            <DtvText
              content={redirectModalHeading?.content}
              variant={'heading'}
              component='h2'
              sx={{
                fontSize: '20px',
                lineHeight: '28.8px',
                marginBottom: '10px',
                [bps.up(bps.values.md)]: {
                  fontSize: '24px'
                }
              }}
            />
          )}
          {redirectModalSubheading?.content && (
            <DtvText
              content={redirectModalSubheading?.content}
              component='p'
              sx={{
                fontSize: '16px',
                lineHeight: '20px',
                marginBottom: '20px',
                [bps.up(bps.values.md)]: {
                  fontSize: '20px'
                }
              }}
            />
          )}
      </DtvBox>
      <DtvBox sx={{
        display: 'flex',
        flexDirection: 'column',
        [bps.up(bps.values.sm)]: {
          justifyContent: 'space-between',
          flexDirection: 'row'
        }
      }}>
          {RedirectCta}
          {CancelCta}
      </DtvBox>
    </DtvBox>
  );
}

export default React.memo(RedirectModal);
